export { withAutoFocus, withSkeleton } from '@sberdevices/plasma-core';
export type { WithAutoFocusProps, WithSkeletonProps } from '@sberdevices/plasma-core';
